import { METRICS } from '../constants';

const loadWindowInfoMonitor = (aggregator) => {
  const { innerWidth, innerHeight } = window;

  if (innerWidth) {
    aggregator(METRICS.WINDOW_WIDTH, `${innerWidth}`);
  }

  if (innerHeight) {
    aggregator(METRICS.WINDOW_HEIGHT, `${innerHeight}`);
  }
};

export { loadWindowInfoMonitor };
